import React from "react";
import CheckIcon from "@material-ui/icons/Check";
import styled from "styled-components";

const PopupBox = styled.div`
  position: fixed;
  bottom: 0;
  z-index: 5;
  right: 10px;
`;

const PopUp = (props) => {
  return (
    <PopupBox>
      <div
        className={`alert alert-${props.danger ? "danger" : "success"} fade-in`}
      >
        {props.description}
        {props.productAdded && <CheckIcon />}
      </div>
    </PopupBox>
  );
};

export default PopUp;
